import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {DataObjectAssignmentType} from "@cm/utils/data-object-assignment"

export const organizationName = "maharam" as const

const options: FilenameSchemaEntry["options"] = {
    imageFormatSpelling: {
        tiff: "tif",
        jpeg: "jpg",
    },
}

export const schemas: FilenameSchemaEntry[] = [
    // maps exports
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_$EXPORT_FORMAT$_$EXPORT_RESOLUTION$",
        isOtherInfoSet: false,
        exportResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_$EXPORT_FORMAT$_72dpi",
        isOtherInfoSet: false,
        exportResolution: "dpi72",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_$EXPORT_FORMAT$_$EXPORT_RESOLUTION$",
        isOtherInfoSet: true,
        exportResolution: "original",
    },
    {
        type: DataObjectAssignmentType.MaterialMapsExport,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_$EXPORT_FORMAT$_72dpi",
        isOtherInfoSet: true,
        exportResolution: "dpi72",
    },

    // tileable renders
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_tile.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        imageResolution: "original",
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialTileableRender,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_tile.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        imageResolution: "original",
        options,
    },

    // thumbnails
    // 7x7 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        imageResolution: "original",
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_7x7Inches,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        imageResolution: "original",
        options,
    },

    // 9x9 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_9x9Inches,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 10x10 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_10x10,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 15x15 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_15x15,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 16x16 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_16x16Inches,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 20x20 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_20x20,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 30x30 cm
    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_30x30,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 8x8 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_8x8Inches,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 13.5x13.5 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_13_5x13_5Inches,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 27x27 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_27x27Inches,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },

    // 32x32 inches
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "MHRM_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: false,
        options,
    },
    {
        type: DataObjectAssignmentType.MaterialThumbnail_32x32Inches,
        schema: "MHRM_$MATERIAL_RANGE_OTHER_INFO$_$MATERIAL_RANGE_NAME$_$MATERIAL_FORMATTED_ARTICLE_ID$_detail.$IMAGE_FORMAT$",
        isOtherInfoSet: true,
        options,
    },
]
